module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction-history/payagain-failedorder/payagain-failedorder.component.css
// module id = ./src/app/transaction-history/payagain-failedorder/payagain-failedorder.component.css
// module chunks = main